import { NOODLE_CREATOR_PERSON_ID } from '@/configuration/client';
import type { Profile } from '@/providers/FeatureFlags/checkFeatureFlag';

const isGladeAdmin = (profile: Profile): boolean => profile?.id === NOODLE_CREATOR_PERSON_ID;

export default isGladeAdmin;
